// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-user-withid{
    width: 100%;
}

.search-user-withid .search-tools{
    display: flex;
}
.search-user-withid .search-tools .search{
    display: flex;
    align-items: center;
    background-color: white;
    padding: 7px 13px;
    width: 260px;
    max-width: 100%;
    border-radius: 22px;
    border: 1px solid transparent;
    transition: var( --main-transition);
}

.search-user-withid .search-tools .search input {
    border: none;
    width: 95%;
}

.search-user-withid .search-tools .search input::placeholder{
    font-size: 12px;
}

.search-user-withid .search-tools .search input:focus{
    outline: none;
}


.search-user-withid .search-tools .search-focus{
    border-color: var(--main-color);
}

.search-user-withid .search-tools .search svg{
    color: var(--gray-color);
}

.search-user-withid .search-tools button{
    background-color: var(--main-color);
    border: none;
    border-radius: 20px;
    padding: 4px 22px;
    cursor: pointer;
    margin: 0px 5px;
    color: white;
    font-weight: bold;
    transition: var(--main-transition);
}

.search-user-withid .search-tools button:hover{
    opacity: .8;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SpecificPerson/SpecificPerson.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf","sourcesContent":[".search-user-withid{\n    width: 100%;\n}\n\n.search-user-withid .search-tools{\n    display: flex;\n}\n.search-user-withid .search-tools .search{\n    display: flex;\n    align-items: center;\n    background-color: white;\n    padding: 7px 13px;\n    width: 260px;\n    max-width: 100%;\n    border-radius: 22px;\n    border: 1px solid transparent;\n    transition: var( --main-transition);\n}\n\n.search-user-withid .search-tools .search input {\n    border: none;\n    width: 95%;\n}\n\n.search-user-withid .search-tools .search input::placeholder{\n    font-size: 12px;\n}\n\n.search-user-withid .search-tools .search input:focus{\n    outline: none;\n}\n\n\n.search-user-withid .search-tools .search-focus{\n    border-color: var(--main-color);\n}\n\n.search-user-withid .search-tools .search svg{\n    color: var(--gray-color);\n}\n\n.search-user-withid .search-tools button{\n    background-color: var(--main-color);\n    border: none;\n    border-radius: 20px;\n    padding: 4px 22px;\n    cursor: pointer;\n    margin: 0px 5px;\n    color: white;\n    font-weight: bold;\n    transition: var(--main-transition);\n}\n\n.search-user-withid .search-tools button:hover{\n    opacity: .8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
